import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { ImageSourceSetData } from "../../../../common/classes/ImageSourceSet";
import { getDefaultImage } from "../../../../utils/GeneralUtils";
import styles from "./EditWorkItem.module.scss";

type Props = {
  index: number;
  title: string;
  img_src?: File | ImageSourceSetData;
  link?: string;
  setIsEditWork: (value: boolean) => void;
  setEditWorkNumber: (i: number) => void;
  deleteWork: (i: number) => void;
  isPreview?: boolean;
};
const EditWorkItem: React.FC<Props> = ({
  index,
  title,
  img_src,
  link,
  setIsEditWork,
  setEditWorkNumber,
  deleteWork,
  isPreview = false,
}) => {
  return (
    <div className={styles["edit-workItem"]}>
      <div className={styles["edit-workItem-left"]}>
        <img
          src={
            !img_src
              ? getDefaultImage()
              : img_src instanceof File
              ? URL.createObjectURL(img_src)
              : img_src.thumbnail?.url
          }
        />
      </div>
      <div className={styles["edit-workItem-right"]}>
        <div
          className={`${styles["edit-workItem-right__text"]} ${styles["title"]}`}
        >
          {title}
        </div>
        <div
          className={`${styles["edit-workItem-right__text"]} ${styles["link"]}`}
        >
          {link ? link : "URL未設定"}
        </div>
        <div className={styles["edit-workItem-right__btn-field"]}>
          {!isPreview ? (
            <>
              <button
                className={`${styles["edit-work-btn"]} ${styles["edit"]}`}
                type="button"
                onClick={() => {
                  setIsEditWork(true);
                  setEditWorkNumber(index);
                }}
              >
                <FontAwesomeIcon icon={["fas", "pen"]} />
                <span>編集</span>
              </button>
              <button
                className={`${styles["edit-work-btn"]} ${styles["delete"]}`}
                type="button"
                onClick={() => deleteWork(index)}
              >
                <FontAwesomeIcon icon={["fas", "trash-alt"]} />
                <span>削除</span>
              </button>
            </>
          ) : (
            <button
              className={`${styles["edit-work-btn"]} ${styles["edit"]}`}
              type="button"
              onClick={() => {
                setIsEditWork(true);
                setEditWorkNumber(index);
              }}
            >
              <span>詳細</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditWorkItem;
